var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h3',[_vm._v("演讲比赛")]),_c('van-button',{attrs:{"plain":"","type":"primary"},on:{"click":_vm.toKecheng}},[_vm._v("购买课程")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }